// default JS
import './index';

// default SCSS
import '../scss/style.scss';